module.exports = __webpack_public_path__ + "static/julialogo-1f44fc12876678f23a4ed7782925ae24.png";